<template>
  <div class="head-menu" :class="{'has-sidebar': isOpenSidebar}" v-if="user">
    <div class="px-10">
      <div class="control-sidebar d-lg-none d-flex">
        <button class="btn" @click="isOpenSidebar = !isOpenSidebar"><i class="fa-solid fa-bars"></i></button>
      </div>
      <div class="menu d-flex">
        <ul>
          <li>
            <a :href="externalDomain" target="_blank"><i class='bx bx-sitemap'></i> Tool domains</a>
          </li>
        </ul>
      </div>
      <div class="d-flex menu menu-right">
        <ul>
          <li>
            <!-- <div class="avatar avatar-sm" :style="{ backgroundImage: `url(${user.avatar})` }"></div> -->
            <div class="dropdown">
              <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ user.name }}
              </a>

              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#" @click="onChangePassword()"><i class="fa-solid fa-key"></i>
                    Đổi mật khẩu</a></li>
                <li><a class="dropdown-item" href="#" @click="onLogout()"><i class="fa-solid fa-right-from-bracket"></i>
                    Thoát</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <sidebar v-if="user" :open="isOpenSidebar" @close="isOpenSidebar = false"/>
  <div v-if="user" class="layout-content" :class="{'has-sidebar': isOpenSidebar}">
    <slot />
  </div>
  <confirmation v-if="user"/>
  <toast v-if="user"/>
  <change-password v-if="user" ref="changePw"/>
</template>

<style lang="scss" scoped>
.layout-content {
  background-color: var(--color-body-bg);
  padding-top: 60px;

  // &.has-sidebar {
  //   @media screen and (min-width: 1024px) {
  //     padding-left: 250px;
  //   }
  // }

  @media screen and (min-width: 1024px) {
    padding-left: 250px;
  }
}

.head-menu {
  background-color: var(--color-top-menu-bg);
  // border-bottom: 1px solid var(--color-top-menu-border);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;

  // &.has-sidebar {
  //   @media screen and (min-width: 1024px) {
  //     padding-left: 250px;
  //   }
  // }
  @media screen and (min-width: 1024px) {
    padding-left: 250px;
  }

  .avatar{
    background-color: #1c4670;
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    // background-image: linear-gradient(to right,
    //     var(--color-body-bg),
    //     var(--color-top-menu-border),
    //     var(--color-body-bg));
  }

  >div {
    display: flex;

    >div {
      &:nth-child(2){flex: 1;}
      height: 60px;
    }

    .menu {
      >ul {
        display: flex;
        list-style: none;
        padding: 0;
        align-items: center;
        height: 100%;
        width: fit-content;

        >li {
          margin-left: 15px;
          margin-right: 15px;
          font-weight: 600;
          display: flex;
          align-items: center;

          a {
            color: var(--color-top-menu-text);

            &:hover {
              color: var(--color-top-menu-text-hover);
            }
          }
        }
      }

      &.menu-center {
        >ul {
          margin: auto;
        }
      }

      &.menu-right {
        justify-content: end;

        >ul {
          margin: 0 0 0 auto;

          >li {
            .avatar {
              margin-right: 15px;
            }
          }
        }
      }
    }

    .logo {
      display: flex;
      align-items: center;
      font-size: 1.3rem;
      color: var(--color-logo);
      font-family: futura;

      img {
        height: 40px;
        margin-right: 10px;
      }
    }
  }
}

.layout-footer {
  text-align: center;
}

.control-sidebar {
  display: flex;

  .btn {
    margin-bottom: 0 !important;
    padding: 0.5rem 1rem;
    color: var(--color-top-menu-text);
    // margin-left: -1rem;
    border: 0;

    &:focus,&:active {
      outline: 0;
      box-shadow: none;
    }
  }
}
</style>

<script>
import Confirmation from "../components/Confirmation/Confirmation.vue";
import Toast from "../components/Toast/Toast.vue";
import Sidebar from './components/Sidebar/index.vue';
import ChangePassword from './components/ChangePassword/index.vue';

export default {
  components: {
    Confirmation,
    Sidebar,
    Toast,
    ChangePassword
  },

  data() {
    return {
      externalDomain: process.env.VUE_APP_EXTERNAL_DOMAIN,
      isOpenSidebar: false
    }
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    onLogout() {
      this.$store.dispatch('confirmation/open', {
        title: 'Thoát',
        type: 'confirmation',
        message: 'Bạn thực sự muốn thoát?',
        options: [
          {
            name: 'cancel',
            label: 'Hủy',
            variant: 'secondary'
          },
          {
            name: 'ok',
            label: 'Thoát',
            variant: 'danger'
          }
        ],
        events: {
          confirm: async (name) => {
            if (name == 'ok') {
              let res = await this.$api.auth.logout().call();

              if (res.success) {
                this.$store.dispatch('auth/logout');
                window.location.reload();
              }
            }
          }
        }
      });
    },

    onChangePassword(){
      this.$refs.changePw.show();
    }
  },

  async beforeMount() {
    let res = await this.$api.config.master().call();
    if (res.success) {
      this.$store.commit('master', res.response.result);
    }
  }
};
</script>
